export enum MarketAreaStatus {
  ACTIVE = "ACTIVE",
  ARCHIVED = "DISABLED",
}

export enum MarketAreaType {
  POLYGON = "POLYGON",
  RADIUS = "RADIUS",
}

export enum MarketAreaAnalysisStatus {
  NOT_ANALYZED = "NOT_ANALYZED",
  IN_PROGRESS = "IN_PROGRESS",
  ANALYZED = "ANALYZED",
  FAILED = "FAILED",
}

export interface ICoordinate {
  latitude: number;
  longitude: number;
}

export interface IPolygonGeometry {
  type: string;
  vertices: ICoordinate[];
}

export interface IRadiusGeometry {
  type: string;
  center: ICoordinate;
  radiusMiles: number;
}

export type TMarketAreaGeometry = IPolygonGeometry | IRadiusGeometry;

export interface IMarketAreaAnalysisError {
  code: string;
  message: string;
}

interface IMarketAreaBase {
  id: string;
  name: string;
  description: string | null;
  analysisStatus: MarketAreaAnalysisStatus;
  status: MarketAreaStatus;
  createdBy: string;
  creationDate: string;
  lastAnalysisDate: string | null;
  analysisError: IMarketAreaAnalysisError | null;
  propertyCount?: number;
}

export type TMarketArea =
  | (IMarketAreaBase & {
      type: MarketAreaType.POLYGON;
      geometry: IPolygonGeometry;
    })
  | (IMarketAreaBase & {
      type: MarketAreaType.RADIUS;
      geometry: IRadiusGeometry;
    });

export interface IMarketAreasInfo {
  totalCount: number;
  activeCount: number;
  objects: TMarketArea[];
}

export interface IMarketAreaTierLimit {
  enabled: boolean;
}

export interface IMarketAreaLimits {
  basic: IMarketAreaTierLimit;
  pro: IMarketAreaTierLimit;
  team: IMarketAreaTierLimit;
}

export interface IMarketAreaField {
  id: string;
  title: string;
  description: string;
  vintage: string;
  categories: string[];
}

export interface IMarketAreaSettings {
  limits: IMarketAreaLimits;
  selectedFields: IMarketAreaField[];
  favoriteFields: IMarketAreaField[];
}
